import { Carousel } from "@/components/cells"
import { ProductCard } from "../ProductCard/ProductCard"
import { listProducts } from "@/lib/data/products"
import { Product } from "@/types/product"
import { HttpTypes } from "@medusajs/types"
import { getProductPrice } from "@/lib/helpers/get-product-price"

export const HomeProductsCarousel = async ({
  locale,
  sellerProducts,
  home,
}: {
  locale: string
  sellerProducts: Product[]
  home: boolean
}) => {
  const {
    response: { products },
  } = await listProducts({
    countryCode: locale,
    queryParams: {
      limit: home ? 4 : 18, //主页:详情页
      order: "created_at",
      //@ts-ignore
      id: sellerProducts.map((s) => s.id),
    },
  })

  if (!products.length && !sellerProducts.length) return null

  const allowedIds = new Set(products.map((p) => String(p.id)))
  const displayProducts: any[] = (
    sellerProducts.length
      ? sellerProducts.filter((p) => allowedIds.has(String(p.id)))
      : products
  ).slice(0, home ? 4 : 18)

  if (!displayProducts.length) return null

  const renderProductCard = (product: Product) => (
    <ProductCard
      key={product.id}
      product={product}
      api_product={
        products.find((p) => String(p.id) === String(product.id))
      }
      locale={locale}
      showAddToCartButton={true}
    />
  )

  return (
    <div className="w-full">
      {/* 主页: carousel */}
      {home && (
        <Carousel
          align="start"
          items={displayProducts.map((product) => (
            <div
              key={product.id}
              className="w-[160px] sm:w-[200px] flex-shrink-0"
            >
              {renderProductCard(product)}
            </div>
          ))}
        />
      )}

      {/* 详情页: 响应式 grid */}
      {!home && (
        <div className="grid grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {displayProducts.map(renderProductCard)}
        </div>
      )}
    </div>
  )
}
